






















import { Component, Watch, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class RandomNumbers extends Vue {
    @Prop()
    public title: string;

    @Prop()
    public value: number;

    @Prop()
    public initial: number;

    private numberString: string = '';

    private* allDigits(exclude?: number) {
        for (const n of Array(10).keys()) {
            if (n !== exclude) {
                yield n;
            }
        }
    }

    @Watch('value')
    private generateNewNumber() {
        const result: number[] = [];
        let values = [...this.allDigits()];
        for (const i of Array(this.value + 1).keys()) {

            const n = Math.floor(Math.random() * values.length);
            result.push(values.splice(n, 1)[0]);

            if (values.length === 0) {
                values = [...this.allDigits(result[result.length - 1])];
            }
        }

        this.numberString = result.join('');
    }

    public correct() {
        this.$emit('input', this.value + 1);
    }

    public wrong() {
        this.generateNewNumber();
    }

    public clear() {
        this.$emit('input', this.initial);
    }

    public created() {
        this.generateNewNumber();
    }
}
